import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67dcf42a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=67dcf42a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dcf42a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67dcf42a')) {
      api.createRecord('67dcf42a', component.options)
    } else {
      api.reload('67dcf42a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=67dcf42a&scoped=true&", function () {
      api.rerender('67dcf42a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/documents/index.vue"
export default component.exports